module.exports = __webpack_public_path__ + "img/CV.b4f9dcdb.jpg";